module.exports = __webpack_public_path__ + "img/ru.f3f79679.svg";